import React, { useEffect, useContext, useState } from 'react';

import { useNavigate } from 'react-router';

import BnplFormContainer from '../components/Bnpl/BnplFormContainer';
import BnplLoading from '../components/Bnpl/BnplLoading';
import { Transition } from '../components/PageElements';
import Layout from '../components/common/Layout';
import { getTenant } from '../config';
import { UserContext } from '../context/UserContext';
import checkUpdateTimeDifference from '../helpers/checkUpdateTimeDifference';

/** helpers */
import { getApplication } from '../service/api';

const AutomatedReviewPage = () => {
  const { setLoading, updateAppData } = useContext(UserContext);
  const [isLong, setIsLong] = useState(false);
  const [cycleTime, setCycleTime] = useState(10000); // 10 seconds - default cycle during first 2 mins;

  const navigate = useNavigate();
  useEffect(() => {
    const timer = setInterval(async () => {
      try {
        const res = await getApplication();
        if (res && res.data) {
          let resIsLong = checkUpdateTimeDifference(res.data.updateDate);
          if (resIsLong) {
            setCycleTime(60000); // set 1 min cycle during next 30 mins wait
            setIsLong(true);
          }
          updateAppData(res.data);
          setLoading(false);
        } else {
          // In case, there is empty res, redirect to dashboard : hopefully will never fall into this case
          navigate('/dashboard');
        }
      } catch (error) {
        console.log(error);
        navigate('/dashboard');
      }
    }, cycleTime);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Layout>
      {getTenant() === 'lightrx' ? (
        <BnplFormContainer hideBack={true}>
          <BnplLoading className={'bnpl-form'}></BnplLoading>
        </BnplFormContainer>
      ) : (
        <Transition isLong={isLong} />
      )}
    </Layout>
  );
};

export default AutomatedReviewPage;
